import React from 'react';
import { Edit, SimpleForm, TextInput, required } from 'react-admin';

export default props => (
  <Edit {...props} title="Editar regra de sorteio">
    <SimpleForm sx={{ maxWidth: 600 }}>
      <TextInput source="name" label="Nome" InputProps={{ autoComplete: 'off' }} validate={required()} sx={{ minWidth: 300 }} />
      <TextInput source="label" label="Descrição" InputProps={{ autoComplete: 'off' }} validate={required()} sx={{ minWidth: 300 }} />
    </SimpleForm>
  </Edit>
)
